// jscpd:ignore-start
import { isPlatformBrowser } from '@angular/common'
import { Component, Input, Output, EventEmitter, OnInit, HostListener, PLATFORM_ID, Inject, ChangeDetectorRef, OnDestroy } from '@angular/core'
import { NGXLogger } from 'ngx-logger'
import { mobileErrorMessage, mobileHyphensComplete, mobileHyphensSetInstead, validateNumber } from 'src/app/core/helpers/app-link'
import { addFocusOutEventSetInvalid, clickoutCloseInput,
  removeInvalidOn, setInvalidOn, setMobileAfterChangeAllHyphens,
  transformLoanAmountWithCommas } from 'src/app/core/helpers/fields-utils'
import { inputAriaCheckActiveState, numberWithCommas } from 'src/app/core/helpers/inputs-helper'
import { OfferInfo } from 'src/app/core/helpers/interfaces'
import { ModalTypes } from 'src/app/core/helpers/modal-store'
import { ModalStateService } from 'src/app/core/services/modal-state.service'
import { PageNavigationService } from 'src/app/core/services/page-navigation.service'
import { mobileSetValueInputArea, scrollModalToTop } from '../options-utils/modal-shared'
// jscpd:ignore-end
@Component({
    selector: 'app-modal-options-add-coapplicant',
    templateUrl: './modal-options-add-coapplicant.component.html',
    styleUrls: ['./modal-options-add-coapplicant.component.scss'],
    standalone: false
})
export class ModalOptionsAddCoapplicantComponent implements OnInit {
  @Input() loanAmount = '2,500'
  @Input() approvedLoanAmount = '2,500'
  @Input() breakpoints: any = [{}]
  @Input() loanAcctId: any = null
  @Input() mobileNumber = ''
  @Input() offersInfo: any = { noAutoPay: {}, autoPay: {}, noAutoPayState: false }
  @Output() sendAppLinkEvent: EventEmitter<any> = new EventEmitter()
  @Output() toggleLoader: EventEmitter<any> = new EventEmitter()


  transformLoanAmountWithCommas = transformLoanAmountWithCommas


  offerInfo: any

  // switcher, true by default
  isAutoPay = true
  isPopup = false

  // window switcher
  public isMonth = false

  constructor(@Inject(PLATFORM_ID) private platformId: object,
              public pageNavigationService: PageNavigationService,
              public modalStateService: ModalStateService,
              public logger: NGXLogger,
              private cdr: ChangeDetectorRef,
  ) {


  }

  onMobileInput(e) {
    mobileHyphensComplete(e, e.target)
  }


  saveState() {
    // this.logger.info('saving state!!')
    this.modalStateService.pushToLocalStorage('externalLink', 'true')
    // this.logger.info('this.layout')
    this.modalStateService.pushToLocalStorage('modalType', ModalTypes.coapplicant)
    this.saveOfferData()
  }


  restoreOfferData() {
    const extObj = this.modalStateService.getFromLocalStorageProps({
      ext_offerInfo: null,
      ext_loanAmount: null,
      ext_mobile: null
    })
    this.offerInfo = extObj.ext_offerInfo
    this.approvedLoanAmount = extObj.ext_loanAmount
    this.mobileNumber = extObj.ext_mobile

    this.modalStateService.pushToLocalStorageProps({
      ext_offerInfo: null,
      ext_loanAmount: null,
      ext_mobile: null
    })
  }

  saveOfferData() {
    this.modalStateService.pushToLocalStorageProps({
      ext_offerInfo: this.offerInfo,
      ext_loanAmount: this.approvedLoanAmount,
      ext_mobile: this.mobileNumber
    })
  }


  ngOnInit() {
    this.cdr.detectChanges()
    if (this.offersInfo.length && this.offersInfo.length >= 1) {
      // this.logger.info('its array')
      this.offerInfo = this.offersInfo[0]
    }
    else {
      // this.logger.info('its object')
      this.offerInfo = this.offersInfo
    }
    this.isAutoPay = !this.offerInfo.noAutoPayState

    // client code
    if (isPlatformBrowser(this.platformId)) {
      scrollModalToTop()
      setTimeout(() => {
        setMobileAfterChangeAllHyphens('appLinkInputModal')
        if (this.modalStateService.getFromLocalStorage('ext_offerInfo')) {
          this.restoreOfferData()
        }
        mobileSetValueInputArea('appLinkInputModalDiv', 'appLinkInputModal', this.mobileNumber)
        if (this.mobileNumber) {
          (document.getElementById('appLinkInputModal') as any).disabled = true
        }
      }, 500)
    }
    setTimeout(() => {
      this.toggleLoader.emit(false)
      this.cdr.detectChanges()
    }, 300)

    this.isMonth = true
  }

  @HostListener('document:click', ['$event'])
  clickout(event) {
    clickoutCloseInput(event)
  }

  inputItemClick(event: any): void
  {
    inputAriaCheckActiveState(event.currentTarget)
  }

  toSendAppLinkEvent(event) {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    const targetDivId = 'appLinkInputModalDiv'
    // TODO: we need loanAcctId, mobile from input, cobo: false, email: '' here
    const numbr = (document.getElementById('appLinkInputModal') as any).value
    if (!numbr || !validateNumber(numbr)) {
      // this.notifier.notify('error', mobileErrorMessage)
      setInvalidOn(targetDivId)
      return
    }
    removeInvalidOn(targetDivId)
    // console.log('send event!')
    this.sendAppLinkEvent.emit({ email: '', phone: numbr, loanAcctId: this.loanAcctId || '', cobo: false })
    this.cdr.detectChanges()
  }


}
